<template>

    <label class="switch-container" for="language-select">

            <select v-model="selected"
                    id="language-select"
                    class="select-lang-switch select-lang-switch-white"
                    @change="updateLang"
                    @click="selectedFocused">

                <template v-for="(lang, min) in languages">

                    <option :value="min" class="option-lang-switch">{{ lang }}</option>

                </template>

            </select>

        <img src="/img/icons/chevron-white-down.svg" class="img__16"/>

    </label>

</template>

<script>

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import Languages from '@/assets/languages.json'

export default {

    name: 'lang-switch',

    props: {

        white: {
            type: Boolean,
            default: false
        },

        green: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        selected() {
            this.updateSelectWidth()
        }
    },

    data() {
        return {
            selected: '',
            languages: {}
        }
    },

    mounted() {

        this.selected = localStorage.getItem('lang') || I18n.get(this)

        const sortedEntries = Object.entries(Languages).sort((first, second) =>
            first[1].localeCompare(second[1])
        )

        this.languages = Object.fromEntries(sortedEntries)

        this.updateSelectWidth();

    },

    methods: {

        updateLang() {
            I18n.set(this, this.selected)
        },

        selectedFocused() {
            Tag.clickAmplitude(this, 'edit_language')
        },

        updateSelectWidth() {
            const span = document.createElement('span')
            span.style.visibility = 'hidden'
            span.style.position = 'absolute'
            span.style.fontSize = '16px'
            span.style.lineHeight = '1.75'
            span.textContent = this.languages[this.selected] || ''
            document.body.appendChild(span)
            const width = span.offsetWidth + 50
            this.$el.querySelector('#language-select').style.width = width + 'px'
            document.body.removeChild(span)
        }

    }

}

</script>

<style lang="scss" scoped>

.select-lang-switch {
    padding: 8px 32px 8px 16px;
    font-size: 16px;
    line-height: 1.75;
    color: $white;
    border: none;
    /*firefox*/
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url('/img/header/arrow-down-white.svg');
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 16px;
    background-color: $aquamarine;
    border-radius: 40px;
    width: min-content;

    &:lang(ar-sa) {
        background-position: 5% 42%;
        padding: 8px 16px 8px 32px;
    }
}

.select-lang-switch > option-lang-switch {
    font-size: 16px;
    font-weight: 500;
    text-align: start;
    color: $white;
    background-color: rgba(255, 255, 255, 0.2);
}
.select-lang-switch:focus {
    outline: none;
    border: none;
    box-shadow: none;
}

</style>
